let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("bs2Gx")).then(() => parcelRequire('04d8x'));